"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.themeToColor = void 0;
var variables_1 = require("../../style/variables");
var themeToColor = function (theme) {
    switch (theme) {
        case 'light':
            return "var(" + variables_1.RootColor.Gray.DARK_4 + ")";
        case 'dark':
            return "var(" + variables_1.RootColor.White + ")";
        default:
            return undefined;
    }
};
exports.themeToColor = themeToColor;
